import React from 'react';
import {useTranslation} from 'react-i18next';
import imageIcon from '../../assets/icons/image-icon.svg';
import {
  Input,
  Icon,
  Wrapper,
  Title,
  ErrorMessage,
  StyledButton,
  HelperText,
} from './styled';

export type UploadFileProps = {
  error?: string | null;
  helperText?: string;
  className?: string;
} & React.ComponentPropsWithRef<'input'>;

const UploadFile = React.forwardRef<HTMLInputElement, UploadFileProps>(
  ({className, onChange, helperText, type, error, ...props}, ref) => {
    const {t} = useTranslation();
    const inputRef = React.useRef<HTMLInputElement>(null);

    React.useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);

    const handleChange = React.useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange?.(event);
        event.target.value = '';
      },
      [onChange],
    );

    return (
      <Wrapper className={className} hasError={!!error}>
        <Input
          type="file"
          ref={inputRef}
          onChange={handleChange}
          accept="image/*"
          {...props}
        />
        <Icon src={imageIcon} alt="Upload" width={33} height={33} />
        <Title>{t('drag_and_drop_your_image_here')}</Title>
        <StyledButton
          onClick={() => inputRef.current?.click()}
          label={t('or_browse_files')}
          link
        />
        <HelperText>{helperText}</HelperText>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </Wrapper>
    );
  },
);

export {UploadFile};
